import React, { useEffect, useState } from 'react';
import rocketmanTransport, { isSoaringGame } from '../../../services/RocketmanTransport';
import { useRocketmanTransport } from '../../rocketman/RocketmanTransportContext';
import Currency from '../../Currency/Currency';
import JackpotOdometer from '../../JackpotOdometer';
import JackpotCurrentWinners from '../../Retail/JackpotCurrentWinners';

export default function RocketPotHolder( {gameName} ) {
  const [currentRocketpotData, setCurrentRocketpotData] = useState([]);

  const rocketmanContext = useRocketmanTransport();
  const jackpotData = rocketmanContext.jackpotData;
  const rocketpotValue = jackpotData?.find(jp => jp.level === 1)?.value || 0;
  const rocketpotLabel = jackpotData?.find(jp => jp.level === 1)?.label || 0;
  const hasJackpot = (name) => currentRocketpotData?.some(jp => jp.jp_level === 1);
  window.setCurrentRocketpotData = setCurrentRocketpotData;

  return (
    <div className="jackpot-cash-holder">
      {currentRocketpotData?.length > 0 && hasJackpot("Rocketpot") ? <JackpotCurrentWinners currentJackpot={currentRocketpotData.filter(jp => jp.jp_level === 1)} /> : null}
      {rocketmanTransport.retail ? <span style={{ marginBottom: -6}} className='jackpot-title-retail mr-2'>{rocketpotLabel}</span> : null} <JackpotOdometer value={Number(Number(rocketpotValue)).toFixed(rocketmanTransport.noOfDecimals)} format={2} duration={60} />  <Currency className={"jackpot-currency " + (rocketmanTransport.r7css ? "r7css" : "")}>{rocketmanTransport.myCurrency}</Currency>
    </div>
  )
}
